import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import styled from "styled-components";
import { DownOutlined } from "@ant-design/icons";
import { Header } from "antd/lib/layout/layout";

import IcOn from "assets/icons/LayoutVer3/IcOn.svg";
import IcOff from "assets/icons/LayoutVer3/IconOff.svg";
import { useDispatch, useSelector } from "react-redux";
import Numpad from "components/Numpad/numpad";
import { BASENAME, BE_URL, FE_URL, USE_SSO, WS_URL } from "constants/constants";
import useWebSocket from "react-use-websocket";
import _, { get } from "lodash";
import {
  changeStatusCRM,
  changeStatusCRMResult,
  getUserStatusResult,
  unMountLogout,
} from "redux/slices/agentMonitor";
import { useNavigate, useParams, useLocation } from "react-router";
import NotificationSound from "assets/sound-noti.wav";
import NotificationVer3 from "pages/Notification/popupVer3";
import {
  Button,
  Divider,
  Dropdown,
  Menu,
  message,
  Modal,
  Popover,
  Tooltip,
  Typography,
} from "antd";
import { updateStatusIC } from "redux/slices/icChatWidget";
import HeaderObjectView from "components/Header/HeaderObjectView";
import AvatarEditor from "react-avatar-editor";
import { NotificationInfo } from "components/Notification/Noti";
import moment from "moment";
import { loadDataReport, updateIsRun } from "redux/slices/customReport";
import { getInfoMailChimp } from "redux/slices/campaign";
import { loadUserDetail, loadUserDetailSuccess } from "redux/slices/user";
import { storeDataCallCenter } from "redux/slices/callCenter";
import { initialize, logout } from "redux/slices/authenticated";
import ModalChangePass from "pages/Users/ModalChangePass";
import { useTranslation, withTranslation } from "react-i18next";
import AuthService from "services/AuthService";
import { logoutAPI } from "redux/api/authenticatedAPIs";
import IconDown from "assets/icons/common/icon-down.svg";
import avatarImg from "assets/images/header/avatar.png";
import { getUpdateTime, updatePercent } from "redux/slices/objectsManagement";
import { hexToRGBA } from "util/helper";
import Check from "assets/icons/header/check.svg";
import Star from "assets/icons/header/star.svg";
import StarActive from "assets/icons/header/star-yellow.svg";
import { markDefaultConfig } from "redux/slices/agentStatus";
import { stopSignalR } from "services/useSignalR";
import {
  disconnectSignalRIC,
  reconnectSignalRIC,
} from "redux/slices/icChatWidget";
import objFieldsPermissionAPI from "services/objFieldsPermissionAPI";
import loadFormCreateService from "services/loadFormCreateAPI";
import getUserAsignRecordService from "services/getUserAsignRecordAPI";
import axios from "axios";
import LOGO_CRM from "assets/images/header/logo_crm_new.png";
import { runAnalysisResult } from "redux/slices/duplicateRules";
import { LIST_OBJECTS_SALE } from "util/staticData";

const HeaderVer3 = ({ collapsed }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userDetail } = useSelector((state) => state.userReducer);
  const { statusIC, stateList } = useSelector(
    (state) => state.icChatWidgetReducer
  );
  const { statusCRM, userStatus } = useSelector(
    (state) => state.agentMonitorReducer
  );

  const { listKnowledgeSetting } = useSelector(
    (state) => state.knowledgeEnhancementReducer
  );

  const { listConfig, defaultStatus } = useSelector(
    (state) => state.agentStatusReducer
  );

  const currentStatusIC = useMemo(
    () => stateList.find((item) => item.id === statusIC),
    [statusIC, stateList]
  );

  const [dataWebSocket, setDataWebSocket] = useState({});
  const [unseenNoti, setUnseenNoti] = useState(0);
  const [listNoti, setListNoti] = useState([]);
  const [hasMoreNoti, setHasMoreNoti] = useState(true);
  const [isLoadingNoti, setIsLoadingNoti] = useState(true);
  const [showNoti, setShowNoti] = useState(false);
  const [showMenuNoti, setShowMenuNoti] = useState(false);
  const [pageNoti, setPageNoti] = useState(0);
  const [showStatus, $showStatus] = useState(false);
  const [showStatusIC, $showStatusIC] = useState(false);
  const { reportID } = useParams();
  const [showModalDisconnect, $showModalDisconnect] = useState(false);
  const [showModalChangePass, setShowModalChangePass] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [configApp, setConfigApp] = useState();
  const [reconnectAttempts, setReconnectAttempts] = useState(0);

  const { avatar_config } = userDetail;
  const audioPlayer = useRef(null);
  const { pathname } = useLocation();

  const { defaultBrandName } = useSelector((state) => state.brandNameReducer);

  useEffect(() => {
    let basename = BASENAME;
    if (BASENAME.endsWith("/")) {
      basename = BASENAME.slice(0, -1);
    }

    axios.get(`${basename}/config.json`).then((res) => {
      setConfigApp(res.data);
    });
  }, []);

  const menuStatus = (listStatus, isIC) => (
    <Menu style={{ width: "20rem", borderRadius: "0.2rem" }}>
      {_.map(listStatus, (item) => (
        <div
          key={item.value}
          onClick={(e) => {
            e.stopPropagation();
            if (isIC) {
              _onChangeStatusIC(item.value);
            } else {
              _onChangeStatus(item.value);
            }
          }}
        >
          <CustomStatus eventKey={item.value} color={item.color}>
            <Typography.Text ellipsis={{ tooltip: item.label }}>
              {item.label}
            </Typography.Text>
          </CustomStatus>
        </div>
      ))}
    </Menu>
  );

  const menuStatusCRM = () => (
    <Menu
      style={{
        width: "21.8rem",
        borderRadius: "0.4rem",
        boxShadow: "0rem 0rem 0.2rem 0rem #919EAB3D",
        margin: "0 1.6rem",
        padding: "0.8rem 0",
        maxHeight: "16rem",
        overflow: "auto",
      }}
    >
      {_.map(
        listConfig?.filter((ele) => ele.value !== "offline" && ele.active),
        (item) => (
          <div
            key={item.value}
            onClick={(e) => {
              e.stopPropagation();
              _onChangeStatus(item.value);
            }}
          >
            <CustomStatusCRM eventKey={item.value} color={item?.color}>
              <Typography.Text ellipsis={{ tooltip: item.label }}>
                {item.label}
              </Typography.Text>
              <div>
                {listConfig.find(
                  (status) =>
                    status.value === statusCRM && status.value === item.value
                ) && (
                  <img
                    src={Check}
                    alt="check"
                    style={{ marginRight: "0.8rem" }}
                  />
                )}

                {_.get(defaultStatus, "default_crm_status.value", "online") ===
                item.value ? (
                  <img src={StarActive} alt="star" />
                ) : (
                  <Tooltip title={t("agentStatus.setAsDefault")}>
                    <img
                      src={Star}
                      alt="star"
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(markDefaultConfig(item.value));
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            </CustomStatusCRM>
          </div>
        )
      )}
    </Menu>
  );

  const content = (
    <div style={{ width: "25rem" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: "1.6rem",
          marginBottom: "2rem",
        }}
      >
        {avatar_config ? (
          <AvatarEditor
            style={{
              width: "12.6rem",
              height: "12.6rem",
              borderRadius: "50%",
            }}
            className="avatar"
            image={
              avatar_config.url && avatar_config.url.length > 0
                ? BE_URL + avatar_config.url
                : avatarImg
            }
            position={avatar_config && avatar_config.position}
            scale={avatar_config && avatar_config.scale}
            border={0}
          />
        ) : (
          <AvatarEditor
            style={{
              width: "12.6rem",
              height: "12.6rem",
              borderRadius: "50%",
            }}
            className="avatar"
            image={avatarImg}
            // position={avatar_config && avatar_config.position}
            // scale={avatar_config && avatar_config.scale}
            border={0}
          />
        )}
      </div>

      <div
        style={{
          padding: "0 2rem",
          textAlign: "center",
        }}
      >
        <Typography.Text
          style={{
            color: "#212B36",
            fontSize: "1.6rem",
            fontFamily: "var(--roboto-700)",
          }}
          ellipsis={{
            tooltip: `${userDetail.Last_Name} ${" "} ${
              userDetail.Middle_Name
            } ${" "} ${userDetail.First_Name}`,
          }}
        >
          {userDetail.Last_Name} {userDetail.Middle_Name}{" "}
          {userDetail.First_Name}
        </Typography.Text>
      </div>

      <div
        style={{
          padding: "0 2rem",
          textAlign: "center",
        }}
      >
        <Typography.Text
          style={{
            color: "#637381",
            fontFamily: "var(--roboto-500)",
          }}
          ellipsis={{
            tooltip: `${userDetail.Email}`,
          }}
        >
          {userDetail.Email}
        </Typography.Text>
      </div>

      <Dropdown
        visible={showStatus}
        onVisibleChange={() => $showStatus(!showStatus)}
        overlay={menuStatusCRM()}
        placement="bottomRight"
        trigger={["click"]}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "2.4rem",
            marginTop: "0.6rem",
          }}
        >
          <UserStatus
            onClick={(e) => {
              e.stopPropagation();
              $showStatus(true);
            }}
            color={listConfig.find((item) => item.value === statusCRM)?.color}
            style={{
              background: hexToRGBA(
                listConfig.find((item) => item.value === statusCRM)?.color ||
                  "#36B37E",
                0.1
              ),
            }}
          >
            <Typography.Text
              ellipsis={{
                tooltip: listConfig.find((item) => item.value === statusCRM)
                  ?.label,
              }}
            >
              {listConfig.find((item) => item.value === statusCRM)?.label}
            </Typography.Text>

            <DownOutlined style={{ fontSize: "1.2rem", color: "#212B36" }} />
          </UserStatus>
        </div>
      </Dropdown>

      <div
        style={{
          padding: "0.2rem 0.8rem",
        }}
        onClick={() => {
          navigate("/profile-setting");
        }}
      >
        <div
          style={{
            padding: "0.8rem",
            fontFamily: "var(--roboto-500)",
            color: "#212B36",
          }}
          className="user-profile"
        >
          {t("user.manageYourAccount")}
        </div>
      </div>

      <div
        style={{
          padding: "0.2rem 0.8rem",
        }}
        onClick={() => setShowModalChangePass(true)}
      >
        <div
          style={{
            padding: "0.8rem",
            fontFamily: "var(--roboto-500)",
            color: "#212B36",
          }}
          className="user-profile"
        >
          {t("common.changePass")}
        </div>
      </div>

      <Divider style={{ marginTop: "0.6rem", marginBottom: 0 }} />

      <div
        style={{
          padding: "0.8rem",
        }}
        onClick={() => {
          if (AuthService) {
            AuthService.checkSession()
              .then(() => {
                AuthService.logout();
                localStorage.removeItem("setting_idToken");
              })
              .catch(() => {
                dispatch(logout());
              });
          }
          if (
            JSON.parse(localStorage.getItem("icIntegration_useIC")) === true &&
            localStorage.getItem("icIntegration_connection_ids")
          ) {
            stopSignalR();
            dispatch(
              disconnectSignalRIC({
                connection_ids: JSON.parse(
                  localStorage.getItem("icIntegration_connection_ids")
                )?.join(","),
              })
            );
          } else {
            localStorage.removeItem("icIntegration_connection_ids");
            localStorage.removeItem("icIntegration_link_api");
            localStorage.removeItem("icIntegration_accessToken");
          }

          logoutAPI();
          dispatch(logout());
          dispatch(
            initialize({
              isAuthenticated: false,
              userInfo: null,
              isInitialized: true,
            })
          );

          localStorage.removeItem("setting_accessToken");
          localStorage.removeItem("setting_refreshToken");
          localStorage.removeItem("themeColor");
          localStorage.removeItem("i18nextLng");
          localStorage.removeItem("redux-root");
          localStorage.removeItem("settings");
          localStorage.removeItem("@ucrm_callCenter_pageIsOpen");
          localStorage.removeItem("@ucrm_callCenter_data");
          localStorage.removeItem("@ucrm_callCenter_phoneInCall");
          localStorage.removeItem("@ucrm_callCenter_interactionDetails");
          localStorage.removeItem("@ucrm_callCenter_syncedCore");
          localStorage.removeItem("@ucrm_callCenter_firstLoad");
          localStorage.removeItem(
            "@ucrm_callCenter_tablInfoSearchSelect_obj_interaction_00000001"
          );
          dispatch(
            storeDataCallCenter({
              dataCallCenter: [],
              phoneInCall: "",
            })
          );
          objFieldsPermissionAPI.clearCache();
          loadFormCreateService.clearCache();
          getUserAsignRecordService.clearCache();

          //IC
          localStorage.removeItem("icIntegration_tenantID");
          localStorage.removeItem("icIntegration_username");
          localStorage.removeItem("icIntegration_is_administrator");
          localStorage.removeItem("icIntegration_refreshToken");
          localStorage.removeItem("icIntegration_current_connectionID");
          localStorage.removeItem("icIntegration_useIC");

          localStorage.removeItem("TableConfig");

          dispatch(loadUserDetailSuccess({}));
          dispatch(unMountLogout());
          if (userDetail.user_root) {
            navigate("/tenant-login");
          } else {
            navigate("/login");
          }
        }}
      >
        <div
          style={{
            padding: "0.8rem",
            fontFamily: "var(--roboto-500)",
            color: "#FF5630",
          }}
          className="user-profile"
        >
          {t("common.signOut")}
        </div>
      </div>
    </div>
  );

  const content_base_app = (
    <div style={{ height: "27.5rem", width: "23rem" }}>
      <iframe
        src={`${window.location.origin}/sso-fe/list-base-app`}
        title="Base App"
        style={{
          height: "100%",
          width: "100%",
          border: "unset",
          borderRadius: 10,
        }}
      />
    </div>
  );

  const _onChangeStatus = (value) => {
    $showStatus(false);
    dispatch(
      changeStatusCRM({
        crm_status: value,
      })
    );
  };

  const _onChangeStatusIC = (value) => {
    $showStatusIC(false);
    dispatch(
      updateStatusIC({
        ic_status: value,
        username: _.get(userDetail, "username_ic", ""),
      })
    );
  };

  const handleShowNoti = () => {
    setShowNoti(!showNoti);
  };

  const handleShowMenuNoti = () => {
    setShowMenuNoti(!showMenuNoti);
  };

  const onOpenNotifications = () => {
    navigate("/notifications");
    setShowNoti(false);
    setShowMenuNoti(false);
  };

  const realTimeNoti = useCallback(() => {
    let tempNoti = [...listNoti];
    tempNoti.forEach((item, idx) => {
      let timeNew = moment(item.created_date).fromNow();
      tempNoti[idx].time = timeNew;
    });
    setListNoti(tempNoti);
  }, [listNoti]);

  const onMarkAllRead = () => {
    setIsLoadingNoti(true);
    setShowMenuNoti(false);
    setListNoti([]);

    sendJsonMessage({
      action: "update_notification_status",
      _id: "all",
    });

    sendJsonMessage({
      action: "get_list_notifications",
      record_per_page: 20,
      page: 0,
    });
  };

  const loadMoreNoti = () => {
    let tempPage = pageNoti + 1;
    setPageNoti(tempPage);

    setTimeout(() => {
      sendJsonMessage({
        action: "get_list_notifications",
        record_per_page: 20,
        page: tempPage,
      });
    }, 1000);
  };

  const onDisconected = () => {
    // localStorage.removeItem('popup-call')
    // localStorage.removeItem('outgoingCall')
  };

  const error = (type, content, duration = 3) => {
    messageApi.open({
      type: type || "error",
      content: content,
      duration: duration,
    });
  };

  const endpoint =
    WS_URL +
    "notifications/" +
    localStorage.getItem("setting_accessToken") +
    "/";

  const { sendJsonMessage } = useWebSocket(endpoint, {
    onMessage: (data) => {
      if (message) message.destroy();
      setReconnectAttempts(0);
      handleMessage(data);
    },
    onClose: () => onDisconected(),
    onError: () => {
      if (reconnectAttempts >= _.get(configApp, "reconnectAttempts", 10)) {
        if (message) message.destroy();

        error(
          "error",
          <div style={{ display: "inline" }}>
            {t("common.connectFail")}
            <span
              style={{
                marginLeft: "0.8rem",
                textDecoration: "underline",
                color: "#0303f7",
                cursor: "pointer",
              }}
              onClick={() => {
                window.location.reload();
              }}
            >
              {t("common.reloadPage")}
            </span>
          </div>,
          0
        );
      } else {
        setReconnectAttempts(reconnectAttempts + 1);
        if (message) message.destroy();
        error(
          "loading",

          <div style={{ display: "inline" }}>
            {t("common.retrySocket")}
            <span
              style={{
                marginLeft: "0.8rem",
                textDecoration: "underline",
                color: "#0303f7",
                cursor: "pointer",
              }}
              onClick={() => {
                window.location.reload();
              }}
            >
              {t("common.reloadPage")}
            </span>
          </div>,
          0
        );
      }
    },
  });

  const handleMessage = (message) => {
    const data = JSON.parse(message.data);
    if (data.event === "Ping Check") return;
    setDataWebSocket(data);
  };

  const endpoint1 =
    WS_URL +
    "agent-monitor/" +
    localStorage.getItem("setting_accessToken") +
    "/";

  // eslint-disable-next-line no-unused-vars
  const { sendJsonMessage: sendJsonMessage2 } = useWebSocket(endpoint1, {
    onMessage: (message) => handleMessage2(message),
  });

  const handleMessage2 = (message) => {
    const data = JSON.parse(message.data);

    if (
      _.isEqual(_.get(data, "event", ""), "user_change_status") ||
      _.isEqual(_.get(data, "event", ""), "get_status")
    ) {
      if (_.get(userDetail, "_id", "") === _.get(data, "data.user_id")) {
        dispatch(
          changeStatusCRMResult({
            crm_status: _.get(data, "data.crm_status"),
          })
        );
      }

      ////agentMonitor
      const userIndex = _.get(userStatus, "data", []).findIndex(
        (item) =>
          _.get(item, "user_status.user_id") === _.get(data, "data.user_id")
      );

      if (userIndex !== -1) {
        let newUserStatus = [...userStatus.data];
        newUserStatus[userIndex] = {
          ...newUserStatus[userIndex],
          user_status: _.get(data, "data"),
        };

        dispatch(
          getUserStatusResult({
            ...userStatus,
            data: newUserStatus,
          })
        );
      }
    }
  };

  const onClickNoti = useCallback(
    (title, objectID, recordID, idNoti, item) => {
      setListNoti([]);

      sendJsonMessage({
        action: "update_notification_status",
        _id: idNoti,
      });

      sendJsonMessage({
        action: "get_list_notifications",
        record_per_page: 20,
        page: 0,
      });

      setShowNoti(false);

      if (LIST_OBJECTS_SALE.includes(get(item, "object_id"))) {
        window.open(`${FE_URL}/sale-view/${objectID}/${recordID}`);
        return;
      }

      if (title.includes("The import process of file")) {
        window.open(`${FE_URL}/view-logs`);
      } else if (item?.category === "duplicate_rule") {
        navigate("/duplicate-rules");
      } else if (
        title.includes("exported successfully") ||
        title.includes("is exporting. We will notify you when it is finished.")
      ) {
        window.open(`${FE_URL}/export-history`);
      } else if (
        title.includes(
          "Error occurs when exporting report, Please contact the Admin."
        )
      ) {
        //
      } else if (objectID === "User") {
        window.open(`${FE_URL}/logs-user`);
      } else if (objectID === "CalendarEvent") {
        if (item?.record_id) {
          localStorage.setItem("id_event", item.record_id);
          setTimeout(() => {
            window.open(`${FE_URL}/calendar-detail`);
          }, 500);
        } else {
          window.open(`${FE_URL}/404`);
        }
      } else {
        if (
          (item?.category === "email" || item?.category === "send_email") &&
          item?.notification_type === "error"
        ) {
          let regex = new RegExp(/style="(.*?)"/);
          let style = item.additional_info.match(regex);
          let body = {};
          if (style) {
            let temp = style[0].replaceAll('"', "'");
            body = JSON.parse(
              item.additional_info.replaceAll("'", '"').replace(style[0], temp)
            );
          } else {
            body = JSON.parse(item.additional_info.replaceAll("'", '"'));
          }
          let typeEmail = body.action_email ? body.action_email : "send_email";
          delete body.action_email;

          localStorage.setItem("emailError", JSON.stringify(body));
          localStorage.setItem("typeEmailError", typeEmail);

          if (typeEmail !== "send_email") {
            window.open(
              `${FE_URL}/consolidated-view/${objectID}/${body.record_id_main}`
            );
          } else {
            window.open(`${FE_URL}/consolidated-view/${objectID}/${recordID}`);
          }
        } else if (objectID && recordID) {
          let flag = false;
          listKnowledgeSetting.forEach((setting) => {
            if (setting.article_setting.obj_article === objectID) {
              flag = true;
            }
          });
          if (flag) {
            window.open(
              `${FE_URL}/knowledge-base-enhancement/details/${objectID}/${recordID}`
            );
          } else {
            window.open(`${FE_URL}/consolidated-view/${objectID}/${recordID}`);
          }
        } else {
          window.open(`${FE_URL}/notifications`);
        }
      }
    },
    /*eslint-disable-next-line*/
    [navigate, sendJsonMessage, dispatch, listKnowledgeSetting]
  );

  useEffect(() => {
    let realTime;
    if (listNoti.length > 0) {
      realTime = setInterval(realTimeNoti, 60000);
    }
    return () => clearInterval(realTime);
  }, [listNoti, realTimeNoti]);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("icIntegration_useIC")) === true) {
      const reconnectIC = setInterval(
        () =>
          dispatch(
            reconnectSignalRIC({
              username: localStorage.getItem("icIntegration_username"),
              connection_id: localStorage.getItem(
                "icIntegration_current_connectionID"
              ),
              tenant_id: localStorage.getItem("icIntegration_tenantID"),
            })
          ),
        600000
      );
      return () => clearInterval(reconnectIC);
    }
  }, [dispatch]);

  useEffect(() => {
    if (Object.keys(dataWebSocket).length > 0) {
      if (dataWebSocket.data?.list_notification) {
        let tempListNoti = [];
        if (dataWebSocket.status === "new_notifications") {
          let decs = dataWebSocket.data.list_notification[0].content;
          let objectID = dataWebSocket.data.list_notification[0].object_id;
          let recorID = dataWebSocket.data.list_notification[0].record_id;
          let ID = dataWebSocket.data.list_notification[0]._id;
          NotificationInfo(
            "New notification",
            decs,
            onClickNoti,
            objectID,
            recorID,
            ID,
            dataWebSocket.data.list_notification[0]
          );

          if (_.get(userDetail, "notification_sound") !== false) {
            audioPlayer.current.play();
          }
          if (
            _.get(userDetail, "windows_push_notification") &&
            dataWebSocket.current_session === dataWebSocket.last_session
          ) {
            if (Notification.permission === "granted") {
              const bodyNoti =
                dataWebSocket.data.list_notification[0].raw_content || decs;
              new Notification("UCRM", {
                body: bodyNoti,
              });
            } else if (
              "Notification" in window &&
              Notification.permission !== "denied"
            ) {
              Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                }
              });
            }
          }

          if (
            reportID &&
            reportID === dataWebSocket.data.list_notification[0].record_id
          ) {
            dispatch(updateIsRun(false));
            dispatch(
              loadDataReport({
                report_id: reportID,
              })
            );
          }

          if (
            dataWebSocket.data.list_notification[0]?.category ===
              "duplicate_rule" &&
            pathname === "/duplicate-rules"
          ) {
            dispatch(
              runAnalysisResult({
                object_id: dataWebSocket.data.list_notification[0]?.object_id,
              })
            );
          }
        }

        dataWebSocket.data.list_notification.map((item) => {
          return tempListNoti.push(item);
        });

        tempListNoti.forEach((item, idx) => {
          tempListNoti[idx].time = moment(item.created_date).fromNow();
        });

        setListNoti((preState) => {
          let tempState = [];
          if (dataWebSocket.status === "new_notifications") {
            tempState = tempListNoti.concat(preState);
          } else {
            tempState = preState.concat(tempListNoti);
          }
          const resultListNoti = tempState.filter(
            (ele, idx, arr) =>
              arr.findIndex((noti) => noti._id === ele._id) === idx
          );

          if (
            dataWebSocket.data.list_notification.length < 20 ||
            resultListNoti.length === 100
          ) {
            setHasMoreNoti(false);
          }

          return resultListNoti;
        });

        setUnseenNoti(dataWebSocket.data.total_unseen);

        if (dataWebSocket.data.total_notifications >= 0) {
          setIsLoadingNoti(false);
        }
      }

      if (dataWebSocket.event === "MailChimp Connection Established") {
        dispatch(getInfoMailChimp());
      }

      if (dataWebSocket.event === "Check for update") {
        dispatch(updatePercent(100));
        dispatch(getUpdateTime());
      }

      if (_.get(dataWebSocket, "event") === "Disconnected") {
        $showModalDisconnect(true);
        dispatch(
          loadUserDetail({
            _id: _.get(userDetail, "_id"),
          })
        );
      }
    }
    // eslint-disable-next-line
  }, [dataWebSocket]);

  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src =
  //     "https://lab.connect247.vn/base-connector-wg/basebs-cti-widget-plugin.js";
  //   script.async = true;
  //   document.body.appendChild(script);

  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  return (
    <CustomHeader className={collapsed ? "collapsed" : ""}>
      {contextHolder}

      {get(defaultBrandName, "media_url") ===
      "/ucrm-ver3/static/media/defaultBrand.d50e51ec.png" ? (
        <img style={{ marginLeft: "2rem" }} src={LOGO_CRM} alt="logo" />
      ) : (
        <AvatarEditor
          style={{
            borderRadius: defaultBrandName.media_config.borderRadius,
            marginLeft: "1.6rem",
          }}
          position={defaultBrandName.media_config.position}
          scale={defaultBrandName.media_config.scale}
          border={defaultBrandName.media_config.border}
          width={
            defaultBrandName.media_config.width < 45
              ? defaultBrandName.media_config.width
              : 45
          }
          height={
            defaultBrandName.media_config.height < 45
              ? defaultBrandName.media_config.height
              : 45
          }
          image={defaultBrandName.media_url}
        />
      )}

      <Wrapper>
        <ListObject>
          <HeaderObjectView />
        </ListObject>
        <Info>
          {userDetail.use_cti && (
            <>
              {/* <div id="basebs_cti_widget_plugin"></div> */}
              <Numpad dataWebSocket={dataWebSocket} userDetail={userDetail} />
            </>
          )}
          {_.get(userDetail, "use_ic", false) && (
            <Dropdown
              visible={showStatusIC}
              onVisibleChange={() => $showStatusIC(!showStatusIC)}
              overlay={menuStatus(
                _.map(
                  stateList?.filter((item) => item.state_key !== "offline"),
                  (state) => {
                    return {
                      label: state.state_name,
                      value: state.id,
                      color: state.color,
                    };
                  }
                ),
                true
              )}
              placement="bottom"
              trigger={["click"]}
            >
              <ICStatus color={_.get(currentStatusIC, "color")}>
                <img
                  style={{ marginRight: "0.8rem" }}
                  src={
                    _.get(currentStatusIC, "state_name") === "Ready"
                      ? IcOn
                      : IcOff
                  }
                  alt=""
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      lineHeight: "normal",
                      color: "#6b6b6b",
                      fontFamily: "var(--roboto-700)",
                    }}
                  >
                    IC Chat
                  </div>
                  <Typography.Text
                    ellipsis={{ tooltip: _.get(currentStatusIC, "state_name") }}
                  >
                    <span
                      className="status"
                      style={{
                        textTransform: "capitalize",
                        color: _.get(currentStatusIC, "color"),
                      }}
                    >
                      {_.get(currentStatusIC, "state_name")}
                    </span>
                  </Typography.Text>
                </div>
                <img
                  src={IconDown}
                  alt="down"
                  style={{
                    marginLeft: "0.5rem",
                    lineHeight: "unset",
                    transform: showStatusIC ? "rotate(180deg)" : "none",
                    transition: "transform 0.3s",
                  }}
                />
              </ICStatus>
            </Dropdown>
          )}

          {USE_SSO && (
            <Popover
              content={content_base_app}
              placement="bottomRight"
              trigger="click"
              overlayClassName="popoverProfile"
            >
              <BaseApp>
                <svg
                  viewBox="0 0 1024 1024"
                  focusable="false"
                  data-icon="bars"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"></path>
                </svg>
              </BaseApp>
            </Popover>
          )}

          <audio ref={audioPlayer} src={NotificationSound} />
          <NotificationVer3
            unseenNoti={unseenNoti}
            listNoti={listNoti}
            hasMoreNoti={hasMoreNoti}
            isLoading={isLoadingNoti}
            showNoti={showNoti}
            showMenuNoti={showMenuNoti}
            onClickNoti={onClickNoti}
            loadMoreNoti={loadMoreNoti}
            onMarkAllRead={onMarkAllRead}
            handleShowNoti={handleShowNoti}
            handleShowMenuNoti={handleShowMenuNoti}
            onOpenNotifications={onOpenNotifications}
          />

          <Popover
            content={content}
            placement="bottomRight"
            trigger="click"
            overlayClassName="popoverProfile"
          >
            <Avatar
              color={listConfig.find((item) => item.value === statusCRM)?.color}
              status={statusCRM}
            >
              {/* <img
                src="https://lab.connect247.vn/ucrmapi-sso/media/tnt_callfinesse_59890767/brand_name/download.png"
                alt=""
              /> */}
              {avatar_config && (
                <AvatarEditor
                  className="avatar"
                  image={
                    avatar_config.url && avatar_config.url.length > 0
                      ? BE_URL + avatar_config.url
                      : avatarImg
                  }
                  position={avatar_config && avatar_config.position}
                  scale={avatar_config && avatar_config.scale}
                  border={0}
                />
              )}
              <div className={"status"} />
            </Avatar>
          </Popover>
        </Info>
      </Wrapper>

      {/* Modal */}
      <ModalChangePass
        showModalChangePass={showModalChangePass}
        onHideModalChangePass={() => setShowModalChangePass(false)}
        getListUser={() => {}}
        user={userDetail}
        isAdmin={false}
      />
      <Modal
        visible={showModalDisconnect}
        footer={[
          <Button
            onClick={() => {
              $showModalDisconnect(false);
            }}
          >
            Ok
          </Button>,
        ]}
      >
        <p> {t("common.notiExtension")} </p>
      </Modal>
    </CustomHeader>
  );
};

export default withTranslation()(memo(HeaderVer3));

const BaseApp = styled.div`
  cursor: pointer;
  border-radius: 2rem;
  padding: 0.2rem 1.4rem;
  border: 0.1rem solid #e0e0e0;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border: ${(props) => `0.1rem solid ${props.theme.main}`};

    svg {
      path:not(.not_active) {
        fill: ${(props) => props.theme.main || "#212B36"};
      }
      rect:not(.not_active) {
        fill: ${(props) => props.theme.main || "#212B36"};
      }

      circle:not(.not_active) {
        fill: ${(props) => props.theme.main || "#212B36"};
      }

      ellipse:not(.not_active) {
        fill: ${(props) => props.theme.main || "#212B36"};
      }

      .stroke_active {
        stroke: ${(props) => props.theme.main || "#212B36"};
      }
    }
  }
`;

const UserStatus = styled.div`
  width: 14.8rem;
  border-radius: 0.6rem;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem 1rem;
  cursor: pointer;
  position: relative;

  .ant-typography {
    font-family: var(--roboto-500);
    font-size: 1.2rem;
    color: #212b36;
    margin-left: 1.4rem;
    width: calc(100% - 3.4rem);
  }

  ::before {
    width: 0.8rem;
    height: 0.8rem;
    background: ${({ color }) => color};
    border-radius: 50%;
    content: "";
    position: absolute;
    top: 0.8rem;
    left: 1.3rem;
  }
`;

const CustomHeader = styled(Header)`
  z-index: 10;
  display: flex;
  align-items: center;
  padding: 0.8rem 1.6rem;
  padding-left: 0.8rem;
  height: 5.2rem;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.05) 0rem 0.4rem 1rem;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1.6rem;
`;

const ListObject = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 1.6rem;
  flex: 1;

  .title {
    font-style: normal;
    font-family: var(--roboto-500);
    font-size: 1.8rem;
    line-height: 2.5rem;

    color: #2c2c2c;
  }
`;

const Info = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0.8rem;
`;

const Avatar = styled.div`
  position: relative;
  margin-right: 0.8rem;
  cursor: pointer;
  height: 4rem;

  .avatar {
    width: 4rem !important;
    height: 4rem !important;
    border-radius: 50% !important;
    cursor: pointer !important;
    transition: all 0.5s;
  }

  .status {
    cursor: pointer;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    position: absolute;
    bottom: 0.2rem;
    right: -0.2rem;
    border: 0.1rem solid #ffffff;
    background: ${({ color }) => color};
  }
`;

const ICStatus = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 0.8rem;
  height: 4.4rem;
  border-radius: 0.5rem;
  transition: 0.2s all ease;

  .ant-typography {
    max-width: 15rem;
    line-height: normal;
    position: relative;
    padding-left: 1.2rem;

    ::before {
      width: 0.8rem;
      height: 0.8rem;
      background: ${({ color }) => color};
      border-radius: 50%;
      content: "";
      position: absolute;
      top: 0.5rem;
      left: 0;
    }
  }

  &:hover {
    background: #919eab14;
    transition: 0.2s all ease;
  }

  .status {
    font-family: var(--roboto-500);
    font-size: 1.2rem;
    color: #6b6b6b;
    position: relative;
  }
`;

const CustomStatus = styled(Menu.Item)`
  position: relative;
  padding-left: 2.4rem;
  font-family: var(--roboto-500);
  line-height: 2.1rem;

  .ant-typography {
    max-width: 15rem;
    color: ${({ color }) => color};
  }

  ::before {
    width: 0.8rem;
    height: 0.8rem;
    background: ${({ color }) => color};
    color: ${({ color }) => color};
    border-radius: 50%;
    content: "";
    position: absolute;
    top: 1.1rem;
    left: 1.2rem;
  }
`;

const CustomStatusCRM = styled(Menu.Item)`
  position: relative;
  font-family: var(--roboto-700);
  padding: 0.4rem 1.6rem;
  padding-left: 2.4rem;
  color: #212b36;

  .ant-typography {
    width: calc(100% - 5.2rem);
  }

  .ant-dropdown-menu-title-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  :hover {
    background: #f4f6f8;
  }

  ::before {
    width: 0.8rem;
    height: 0.8rem;
    background: ${({ color }) => color};
    color: ${({ color }) => color};
    border-radius: 50%;
    content: "";
    position: absolute;
    top: 1.1rem;
    left: 1.2rem;
  }
`;
